import moment from 'moment/moment'

export function transformRawEvent(event) {
  return {
    ...event,
    dateStartMoment: event.dateStart ? moment(event.dateStart) : null,
    dateEndMoment: event.dateEnd ? moment(event.dateEnd) : null,
    timeStartMoment: event.timeStart ? moment(`2023-01-01 ${event.timeStart}`) : null,
    timeEndMoment: event.timeEnd ? moment(`2023-01-01 ${event.timeEnd}`) : null,
  }
}
